// extracted by mini-css-extract-plugin
export default {"card_group_list_wrap":"style_card_group_list_wrap__e0+z3","card_list_wrap":"style_card_list_wrap__aYPsf","card_box":"style_card_box__XtVe7"};